import germanMessages from 'ra-language-german';

export default {
    ...germanMessages,
    resources: {
        ui: {
            showAllProperties: "Zeige alle Eigenschaften",
            hideAllProperties: "Verberge alle Eigenschaften",
        },
        base: {
            name: "Basis",
            fields: {
                aspect: "Aspekt",
                name: "Name",
                description: "Beschreibung",
                created: "Erstellt am",
                modified: "Geändert am",
                origin: "Ursprung",
                type: {
                    one: "Typ",
                    other: "Typen"
                },
                scope: {
                    one: "Bereich",
                    other: "Bereiche"
                },
            }
        },
        products: {
            name: "Produkte",
            fields: {
                name: 'Name',
                created: 'Erstellt',
                modified: 'Geändert',
                type: {
                    one: "Typ",
                    other: "Typen"
                },
                scope: {
                    one: "Bereich",
                    other: "Bereiche"
                },
                fulltext: "Volltext (langsam)"
            },
            selectEmpty: {
                type: 'Typ auswählen',
                scope: 'Bereich auswählen'
            },
            description: 'Hier werden alle Produkte, Komponenten, Instanzen, Geräte, Systeme usw. angezeigt.'
        },
        functions: {
            name: "Funktionen",
            fields: {
                name: 'Name',
                created: 'Erstellt',
                modified: 'Geändert',
                type: {
                    one: "Typ",
                    other: "Typen"
                },
                scope: {
                    one: "Bereich",
                    other: "Bereiche"
                },
                fulltext: "Volltext (langsam)"
            },
            selectEmpty: {
                type: 'Typ auswählen',
                scope: 'Bereich auswählen'
            },
            description: 'Kundenanforderungen, funktionale Anfragen, produktunabhängige Funktionen finden Sie hier.',
        },
        locations: {
            name: "Standorte",
            fields: {
                name: 'Name',
                created: 'Erstellt',
                modified: 'Geändert',
                type: {
                    one: "Typ",
                    other: "Typen"
                },
                scope: {
                    one: "Bereich",
                    other: "Bereiche"
                },
                fulltext: "Volltext (langsam)"
            },
            selectEmpty: {
                type: 'Typ auswählen',
                scope: 'Bereich auswählen'
            },
            description: 'Standortkoordinaten, Gebäudeabhängigkeiten, räumliche Anordnungen werden hier angezeigt.',
        },
        organisations: {
            name: 'Organisationen',
            fields: {
                name: 'Name',
                created: 'Erstellt',
                modified: 'Geändert',
                type: {
                    one: "Typ",
                    other: "Typen"
                },
                scope: {
                    one: "Bereich",
                    other: "Bereiche"
                },
                fulltext: "Volltext (langsam)"
            },
            selectEmpty: {
                type: 'Typ auswählen',
                scope: 'Bereich auswählen'
            },
            description: 'Organisatorische Informationen finden Sie hier.',
        },
        types: {
            name: "Typen"
        },
        scopes: {
            name: "Bereiche"
        },
        aspects: {
            name: "Aspekte"
        },
        tags: {
            name: "Tags"
        }
    }
};
